module.exports = __webpack_public_path__ + "img/Layout-Verse-mobile.94513260.png";